import { render, staticRenderFns } from "./ColoredStatus.vue?vue&type=template&id=0981b032&scoped=true"
import script from "./ColoredStatus.vue?vue&type=script&lang=ts"
export * from "./ColoredStatus.vue?vue&type=script&lang=ts"
import style0 from "./ColoredStatus.vue?vue&type=style&index=0&id=0981b032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0981b032",
  null
  
)

export default component.exports